import { buildTestId } from '~/utils/buildTestId';

export const ARCHIVE_TABS = {
  users: 0,
  departments: 1,
} as const;

const ARCHIVE_TABS_LABEL: Record<
  (typeof ARCHIVE_TABS)[keyof typeof ARCHIVE_TABS],
  string
> = {
  [ARCHIVE_TABS.users]: 'Users',
  [ARCHIVE_TABS.departments]: 'Departments',
} as const;

type ArchiveTabsKey = keyof typeof ARCHIVE_TABS;
export type ArchiveTabsValue = (typeof ARCHIVE_TABS)[keyof typeof ARCHIVE_TABS];

export const ArchiveTabsConfig = ({ testID }: { testID: string }) =>
  (Object.keys(ARCHIVE_TABS) as ArchiveTabsKey[]).map((key) => {
    const label = ARCHIVE_TABS_LABEL[ARCHIVE_TABS[key]];

    return {
      label,
      'aria-label': label,
      testID: buildTestId({ testID, suffix: ['tab', label] }),
    };
  });
